/* eslint-disable eqeqeq */
// @ts-nocheck
import { CFormCheck, CFormInput, CFormSelect, CSpinner } from "@coreui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import InfiniteScrollSelect from "../../../components/ui/InfiniteScrollSelect";
import PasswordInput from "../../../components/inputs/PasswordInput";
import RichTextEditor from "../../../components/ui/RichTextEditor";
import { FormMode } from "../../../helpers/enums";
import { verifyFileList } from "../../../helpers/general";
import { useAuth } from "../../../hooks/useAuth";
import { useCookie } from "../../../hooks/useCookie";
import { useToast } from "../../../hooks/useToast";
import { general } from "../../../locales/general";
import apiService from "../../../service/apiService";
import FileUploader from "../../../components/ui/FileUploader";
import { Switch } from "@mantine/core";
import { Field, FormSection } from "../../../components/ui/FormUi";
import { ACCENT } from "../PlacesTable";

// interface placeData {
//   name: string;
//   categoryId: string;
//   cityId: number;
//   picture: File;
//   logo: File;
//   hasParking: string;
//   priceRange: string[];
//   paymentMethods: string[];
//   mainType: string;
//   secondaryType: string;
//   speciality: string;
//   chefName: string;
//   averagePrice: number;
//   keywords: string[];
//   phone: string;
//   email: string;
//   website: string;
//   facebookURL: string;
//   instagramURL: string;
//   address: string;
//   latitude: number;
//   longitude: number;
//   placeAdmin: string;
//   servicesSectionTitle: string;
//   videoIds?: string[];
// }

const YesNo = ({ id, reg }: { id: string; reg: any }) => (
  <CFormSelect id={id} {...reg}>
    <option value="true">Oui</option>
    <option value="false">Non</option>
  </CFormSelect>
);

export default function NewPlace({ mode = FormMode.CREATE }) {
  const [formLoading, setFormLoading] = useState(false);
  const { isAdmin } = useAuth();
  const { token } = useCookie("vToken");
  const { toastError, toastSuccess } = useToast();
  const params = useParams();
  const navigate = useNavigate();
  const [description, setDescription] = useState("");
  const [showUser, setShowUser] = useState(false);
  const [managers, setManagers] = useState([]);
  const [picturePreview, setPicturePreview] = useState("");
  const [logoPreview, setLogoPreview] = useState("");

  const schema = yup.object({
    name: yup.string().required(),
    picture: yup.mixed().required("Ce champ est obligatoire"),
    logo: yup.mixed().required("Ce champ est obligatoire"),
    address: yup.string().required("Ce champ est obligatoire"),
    phone: yup.string().required("Ce champ est obligatoire"),
    // description: yup.string().notRequired(),
    googleMapUrl: yup.string().nullable(),
    emdedGoogleMapUrl: yup.string().nullable(),
    email: yup
      .string()
      .email("Veuillez saisir une adresse e-mail valide")
      .required("Ce champ est obligatoire"),
    website: yup
      .string()
      .url("Veuillez saisir une adresse URL valide")
      .nullable("Ce champ est obligatoire"),
    facebookURL: yup
      .string()
      .url("Veuillez saisir une adresse URL valide")
      .nullable(),
    instagramURL: yup
      .string()
      .url("Veuillez saisir une adresse URL valide")
      .nullable(),
    tiktokURL: yup
      .string()
      .url("Veuillez saisir une adresse URL valide")
      .nullable(),
    hasParking: yup.string().required("Ce champ est obligatoire"),
    priceRangeMin: yup
      .number()
      .nullable(true)
      .typeError()
      .transform((_, val) => (val ? Number(val) : null)),
    priceRangeMax: yup
      .number()
      .nullable(true)
      .typeError()
      .transform((_, val) => (val ? Number(val) : null)),
    // paymentMethods: yup.string().required("Ce champ est obligatoire"),
    keywords: yup.string().required("Ce champ est obligatoire"),
    categoryId: yup
      .object()
      .required("Ce champ est obligatoire")
      .typeError("Ce champ est obligatoire"),
    cityId: yup
      .object()
      .required("Ce champ est obligatoire")
      .typeError("Ce champ est obligatoire"),
    servicesSectionTitle: yup.string().required("Ce champ est obligatoire"),
    mainType: yup.string().nullable(),
    secondaryType: yup.string().nullable(),
    speciality: yup.string().nullable(),
    chefName: yup.string().nullable(),
    videoIds: yup.string().nullable(),
    // company fields
    companyName: yup.string().nullable(),
    companyAddress: yup.string().nullable(),
    IF: yup.string().nullable(),
    IC: yup.string().nullable(),
    rib: yup.string().nullable(),
    paymentMethodsInPlace: yup.boolean().nullable(),
    paymentMethodsCreditCard: yup.boolean().nullable(),
    paymentMethodsWafacash: yup.boolean().nullable(),
    paymentMethodsStripe: yup.boolean().nullable(),
    paymentMethodsBalance: yup.boolean().nullable(),
    isEventsEnabled: yup.boolean().nullable(),
    hoursStep: yup
      .number()
      .integer()
      .positive()
      .required("Ce champ est obligatoire")
      .typeError("Ce champ est obligatoire"),
    taxiActive: yup.string().required("Ce champ est obligatoire"),

    latitude: yup.number().when("taxiActive", {
      is: "true" || true,
      then: () =>
        yup
          .number()
          .required("Ce champ est obligatoire")
          .min(-90, "Ce champ doit être compris entre -90 et 90")
          .max(90, "Ce champ doit être compris entre -90 et 90")
          .typeError("Ce champ est obligatoire"),
      otherwise: () =>
        yup
          .number()
          .nullable()
          .optional()
          .min(-90, "Ce champ doit être compris entre -90 et 90")
          .max(90, "Ce champ doit être compris entre -90 et 90")
          .typeError("Ce champ est obligatoire")
          .transform((_, val) => {
            const result = val == Number(val) ? Number(val) : null;
            return result;
          }),
    }),
    longitude: yup.number().when("taxiActive", {
      is: "true" || true,
      then: () =>
        yup
          .number()
          .required("Ce champ est obligatoire")
          .min(-180, "Ce champ doit être compris entre -180 et 180")
          .max(180, "Ce champ doit être compris entre -180 et 180")
          .typeError("Ce champ est obligatoire"),
      otherwise: () =>
        yup
          .number()
          .nullable(true)
          .optional()
          .min(-180, "Ce champ doit être compris entre -180 et 180")
          .max(180, "Ce champ doit être compris entre -180 et 180")
          .typeError("Ce champ est obligatoire")
          .transform((_, val) => {
            const result = val == Number(val) ? Number(val) : null;
            return result;
          }),
    }),
    addressName: yup.string().when("taxiActive", {
      is: "true" || true,
      then: () => {
        return yup
          .string()
          .transform((_, val: string) => {
            return val?.trim();
          })
          .required("Ce champ est obligatoire");
      },
      otherwise: () => yup.string().nullable(),
    }),
    venezPercentage: yup.number().nullable(true).typeError().default(null),
    // end company fields
    // minNumberOfPersons: yup.number().default(1),
    // stepOfNumberOfPersons: yup.number().default(1),
    ...(isAdmin
      ? {
          averagePrice: yup
            .number()
            .nullable(true)
            .typeError()
            .transform((_, val) => (val ? Number(val) : null)),
          // config fields
          supportTableSelection: yup
            .string()
            .required("Ce champ est obligatoire"),
          supportReservations: yup
            .string()
            .required("Ce champ est obligatoire"),
          authConfirmBookings: yup
            .string()
            .required("Ce champ est obligatoire"),
          activateTVA: yup.string().required("Ce champ est obligatoire"),
          isVisible: yup.string().required("Ce champ est obligatoire"),
          // PlaceAdmin fields
          adminFullName: yup.string().nullable().optional(),
          adminEmail: yup
            .string()
            .email("Veuillez saisir une adresse e-mail valide")
            .nullable()
            .optional(),
          adminPhone: yup.string().nullable().optional(),
          points: yup.number().nullable().optional(),
          ...(mode === FormMode.CREATE
            ? {
                adminPassword: yup.string().nullable().optional(),
              }
            : {}),
        }
      : {}),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control: formControl,
    setValue: setFormValue,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      hoursStep: 30,
      minNumberOfPersons: 1,
      stepOfNumberOfPersons: 1,
    },
  });
  const taxiActiveValue = watch("taxiActive");

  // console.log("errors", errors);

  useEffect(() => {
    if (mode === FormMode.UPDATE && params?.id) {
      const formFields = Object.keys(schema.fields);
      const placeGetRequest = apiService.MakeGetRequest(
        `places/${params.id}`,
        token,
      );
      const placeAdminGetRequest = apiService.MakeGetRequest(
        `places/${params.id}/place-admin`,
        token,
      );

      Promise.all([placeGetRequest, placeAdminGetRequest]).then(
        ([placeResp, placeAdminResp]) => {
          const paymentOptions = placeResp.paymentOptions ?? [];
          if (paymentOptions?.includes("in_place")) {
            setFormValue("paymentMethodsInPlace", true);
          }
          if (paymentOptions?.includes("credit_card")) {
            setFormValue("paymentMethodsCreditCard", true);
          }
          if (paymentOptions?.includes("wafacash")) {
            setFormValue("paymentMethodsWafacash", true);
          }
          if (paymentOptions?.includes("stripe")) {
            setFormValue("paymentMethodsStripe", true);
          }
          if (paymentOptions?.includes("user_balance")) {
            setFormValue("paymentMethodsBalance", true);
          }

          if (placeResp.managers && Array.isArray(placeResp.managers)) {
            setManagers(placeResp.managers);
          }
          // placeAdmin fields
          setFormValue("adminFullName", placeAdminResp.fullName);
          setFormValue("adminEmail", placeAdminResp.email);
          setFormValue("adminPhone", placeAdminResp.phone);
          // place fields
          setFormValue("picture", placeResp.image);
          setFormValue("logo", placeResp.logoImage);
          setPicturePreview(placeResp.image ?? "");
          setLogoPreview(placeResp.logoImage ?? "");
          setFormValue("categoryId", placeResp.category);
          setFormValue("cityId", placeResp.city);
          setDescription(placeResp?.description);
          // setFormValue("keywords", placeResp.keywords?.join(","));
          setFormValue("paymentMethods", placeResp.paymentMethods?.join(", "));
          setFormValue("priceRangeMin", placeResp.priceRange?.[0] ?? null);
          setFormValue("priceRangeMax", placeResp.priceRange?.[1] ?? null);
          setFormValue("isEventsEnabled", placeResp.isEventsEnabled);
          setFormValue("venezPercentage", placeResp.venezPercentage);
          setFormValue("points", placeResp.points);

          Object.entries(placeResp).forEach((entry) => {
            if (formFields.indexOf(entry[0]) !== -1) {
              if (
                entry[0] === "paymentMethods" ||
                entry[0] === "keywords" ||
                entry[0] === "videoIds"
              ) {
                setFormValue(entry[0], entry[1]?.join(","));
              } else {
                setFormValue(entry[0], entry[1]);
              }
            }
            //
          });
        },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.id]);

  const selectedCategory = watch("categoryId");
  const categoryLabel = (
    selectedCategory?.label ??
    selectedCategory?.name ??
    ""
  ).toLowerCase();

  const isRestaurantCategory =
    categoryLabel.includes("restaurants") || categoryLabel.includes("brunch");

  const createPlaceMutation = useMutation(async (placeData) => {
    return await apiService.MakePostRequest("places", placeData, token, true);
  });

  const updatePlaceMutation = useMutation(async (placeData) => {
    return await apiService.MakePutRequest(
      `places/${params.id}`,
      placeData,
      token,
      true,
    );
  });

  const updatePlaceAdminMutation = useMutation(async (placeAdminData) => {
    return await apiService.MakePutRequest(
      `places/${params.id}/place-admin`,
      placeAdminData,
      token,
    );
  });

  const createPlace = async (data) => {
    try {
      setFormLoading(true);
      await createPlaceMutation.mutateAsync(data);
      toastSuccess(general.fr.message.placeCreated);
      navigate(-1);
    } catch (error) {
      setFormLoading(false);
      toastError(general.fr.message.operationFailed);
    }
  };

  const updatePlace = async (data) => {
    try {
      setFormLoading(true);
      const updatePlaceReq = updatePlaceMutation.mutateAsync(data);
      const updatePlaceAdminReq = updatePlaceAdminMutation.mutateAsync({
        fullName: data.adminFullName,
        email: data.adminEmail,
        phone: data.adminPhone,
      });
      if (isAdmin) {
        await Promise.all([updatePlaceReq, updatePlaceAdminReq]);
        toastSuccess(general.fr.message.placeUpdated);
        navigate(-1);
      } else {
        await updatePlaceReq;
        toastSuccess(general.fr.message.placeUpdated);
        navigate(-1);
      }
    } catch (error) {
      setFormLoading(false);
      toastError(general.fr.message.operationFailed);
    }
  };

  const addManager = (selectedUser) => {
    if (!selectedUser) return;
    const usersToAdd = Array.isArray(selectedUser)
      ? selectedUser
      : [selectedUser];
    const newManagers = [...managers];

    usersToAdd.forEach((user) => {
      // Prevent duplicates
      if (!newManagers.find((m) => m.id === user.id)) {
        newManagers.push(user);
      }
    });
    setManagers(newManagers);
  };

  const removeManager = (managerId) => {
    setManagers(managers.filter((m) => m.id !== managerId));
  };

  const onSubmit = async (dataArg) => {
    const data = { ...dataArg };
    try {
      const imageFile = verifyFileList(data.picture);
      data.picture = imageFile;
      const logoFile = verifyFileList(data.logo);
      data.logo = logoFile;
      data.categoryId = data.categoryId.id;
      // data.latitude = data.cityId.latitude;
      // data.longitude = data.cityId.longitude;
      data.priceRange = [data.priceRangeMin, data.priceRangeMax];
      data.cityId = data.cityId.id;
      data.venezPercentage = data.venezPercentage ?? null;
      const paymentOptions = [];
      if (data.paymentMethodsInPlace) {
        paymentOptions.push("in_place");
      }
      if (data.paymentMethodsCreditCard) {
        paymentOptions.push("credit_card");
      }
      if (data.paymentMethodsWafacash) {
        paymentOptions.push("wafacash");
      }
      if (data.paymentMethodsStripe) {
        paymentOptions.push("stripe");
      }
      if (data.paymentMethodsBalance) {
        paymentOptions.push("user_balance");
      }
      data.paymentOptions = JSON.stringify(paymentOptions);
      data.managerIds = managers.map((m) => m.id);

      if (mode === FormMode.UPDATE) {
        updatePlace({ ...data, description });
      } else {
        data.placeAdmin = JSON.stringify({
          fullName: data.adminFullName,
          email: data.adminEmail,
          phone: data.adminPhone,
          password: data.adminPassword,
        });
        createPlace({ ...data, description });
      }
    } catch (error) {
      setFormLoading(false);
      console.log(error);
      toastError(general.fr.message.operationFailed);
    }
  };

  const isCreate = mode !== FormMode.UPDATE;
  const taxiOn = taxiActiveValue === "true" || taxiActiveValue === true;

  return (
    <div className="vz-form px-2">
      {/* Header */}
      <div
        style={{
          ...{
            backgroundColor: "#fff",
            borderRadius: 16,
            padding: "16px 20px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          },
        }}
        className="d-flex justify-content-between align-items-center mb-3"
      >
        <div>
          <h4 className="fs-4 fw-bold mb-0">
            {isCreate
              ? "Ajouter un établissement"
              : "Mettre à jour l'établissement"}
          </h4>
          <div className="text-muted" style={{ fontSize: 13 }}>
            Les champs marqués d'une * sont obligatoires
          </div>
        </div>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="btn btn-outline-secondary rounded-pill px-3"
        >
          ← Retour
        </button>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        {/* General */}
        <FormSection title="Informations générales">
          <Field
            label="Nom"
            htmlFor="name"
            required
            error={errors.name?.message}
          >
            <CFormInput
              id="name"
              placeholder="Nom de l'établissement"
              {...register("name")}
            />
          </Field>

          <Field
            label="Catégorie"
            htmlFor="categoryId"
            required
            error={errors.categoryId?.message}
          >
            <Controller
              name="categoryId"
              control={formControl}
              render={({ field }) => (
                <InfiniteScrollSelect
                  id="categoryId"
                  isClearable={false}
                  getOptionLabel={(o) => o?.label}
                  getOptionValue={(o) => o.id}
                  isOptionSelected={(o, selected) =>
                    o?.id === selected?.[0]?.id
                  }
                  url={{ path: "categories" }}
                  {...field}
                />
              )}
            />
          </Field>

          <Field
            label="Ville"
            htmlFor="cityId"
            required
            error={errors.cityId?.message}
          >
            <Controller
              name="cityId"
              control={formControl}
              render={({ field }) => (
                <InfiniteScrollSelect
                  id="cityId"
                  isClearable={false}
                  getOptionLabel={(o) => o?.label}
                  getOptionValue={(o) => o.id}
                  isOptionSelected={(o, selected) =>
                    o?.id === selected?.[0]?.id
                  }
                  url={{ path: "cities" }}
                  formatOptions={(cities: City[]) =>
                    cities.sort((a, b) =>
                      a.label.localeCompare(b.label, undefined, {
                        sensitivity: "base",
                        usage: "sort",
                      }),
                    )
                  }
                  {...field}
                />
              )}
            />
          </Field>

          <Field
            label="Adresse"
            htmlFor="address"
            required
            error={errors.address?.message}
          >
            <CFormInput
              id="address"
              placeholder="Adresse"
              {...register("address")}
            />
          </Field>

          <Field
            label="URL de la localisation"
            htmlFor="googleMapUrl"
            error={errors.googleMapUrl?.message}
          >
            <CFormInput
              id="googleMapUrl"
              type="url"
              placeholder="https://"
              {...register("googleMapUrl")}
            />
          </Field>

          <Field
            label="URL embed de la carte Google"
            htmlFor="emdedGoogleMapUrl"
            error={errors.emdedGoogleMapUrl?.message}
          >
            <CFormInput
              id="emdedGoogleMapUrl"
              type="url"
              placeholder="https://"
              {...register("emdedGoogleMapUrl")}
            />
          </Field>

          <Field
            label="Parking"
            htmlFor="hasParking"
            required
            error={errors.hasParking?.message}
          >
            <CFormSelect id="hasParking" {...register("hasParking")}>
              <option value="">Choisissez une option</option>
              <option value="true">Oui</option>
              <option value="false">Non</option>
            </CFormSelect>
          </Field>

          <Field label="Gamme de prix" htmlFor="priceRangeMin">
            <div className="d-flex align-items-center gap-2">
              <CFormInput
                id="priceRangeMin"
                type="number"
                placeholder="Min"
                {...register("priceRangeMin")}
              />
              <span className="text-muted">–</span>
              <CFormInput
                id="priceRangeMax"
                type="number"
                placeholder="Max"
                {...register("priceRangeMax")}
              />
            </div>
          </Field>

          <Field
            label="Modes de paiement"
            htmlFor="paymentMethods"
            required
            hint="Séparer par une virgule"
            error={errors.paymentMethods?.message}
          >
            <CFormInput
              id="paymentMethods"
              placeholder="Espèces, Carte bancaire"
              {...register("paymentMethods")}
            />
          </Field>

          <Field
            label="Mots-clés"
            htmlFor="keywords"
            required
            hint="Séparer par une virgule"
            error={errors.keywords?.message}
          >
            <CFormInput id="keywords" {...register("keywords")} />
          </Field>

          <Field
            label="Titre de la section services"
            htmlFor="servicesSectionTitle"
            required
            error={errors.servicesSectionTitle?.message}
          >
            <CFormInput
              id="servicesSectionTitle"
              {...register("servicesSectionTitle")}
            />
          </Field>

          {isAdmin && (
            <Field
              label="Points"
              htmlFor="points"
              error={errors.points?.message}
            >
              <CFormInput
                id="points"
                type="number"
                placeholder="Points"
                {...register("points")}
              />
            </Field>
          )}
        </FormSection>

        {/* Media */}
        <FormSection title="Images">
          <Field
            label="Grande image"
            htmlFor="picture"
            required
            hint="Taille préférée 1425×520"
            error={errors.picture?.message}
          >
            <FileUploader
              id="picture"
              name="picture"
              accept="image/png,image/jpeg,image/jpg"
              required={isCreate}
              {...register("picture")}
              file={picturePreview}
            />
          </Field>
          <Field
            label="Petite image (logo)"
            htmlFor="logo"
            required
            hint="Taille préférée 150×150"
            error={errors.logo?.message}
          >
            <FileUploader
              id="logo"
              name="logo"
              accept="image/png,image/jpeg,image/jpg"
              required={isCreate}
              {...register("logo")}
              file={logoPreview}
            />
          </Field>
        </FormSection>

        {/* Restaurant only */}
        {isRestaurantCategory && (
          <FormSection
            title="Restauration"
            description="Visible pour les restaurants et brunchs"
          >
            <Field
              label="Menu principal"
              htmlFor="mainType"
              error={errors.mainType?.message}
            >
              <CFormInput id="mainType" {...register("mainType")} />
            </Field>
            <Field
              label="Menu secondaire"
              htmlFor="secondaryType"
              error={errors.secondaryType?.message}
            >
              <CFormInput id="secondaryType" {...register("secondaryType")} />
            </Field>
            <Field
              label="Spécialités"
              htmlFor="speciality"
              error={errors.speciality?.message}
            >
              <CFormInput id="speciality" {...register("speciality")} />
            </Field>
            <Field
              label="Nom du chef"
              htmlFor="chefName"
              error={errors.chefName?.message}
            >
              <CFormInput id="chefName" {...register("chefName")} />
            </Field>
            <Field
              label="Panier moyen"
              htmlFor="averagePrice"
              error={errors.averagePrice?.message}
            >
              <CFormInput
                id="averagePrice"
                type="number"
                readOnly={!isAdmin}
                {...register("averagePrice")}
              />
            </Field>
          </FormSection>
        )}

        {/* Contact */}
        <FormSection title="Contact et réseaux sociaux">
          <Field
            label="Téléphone"
            htmlFor="phone"
            required
            error={errors.phone?.message}
          >
            <CFormInput
              id="phone"
              placeholder="Téléphone"
              {...register("phone")}
            />
          </Field>
          <Field
            label="Email"
            htmlFor="email"
            required
            error={errors.email?.message}
          >
            <CFormInput
              id="email"
              type="email"
              autoComplete="new-email"
              {...register("email")}
            />
          </Field>
          <Field
            label="Site web"
            htmlFor="website"
            hint="Ex : https://www.exemple.com/"
            error={errors.website?.message}
          >
            <CFormInput
              id="website"
              type="url"
              placeholder="https://"
              {...register("website")}
            />
          </Field>
          <Field
            label="Facebook"
            htmlFor="facebookURL"
            hint="Ex : https://www.facebook.com/exemple"
            error={errors.facebookURL?.message}
          >
            <CFormInput
              id="facebookURL"
              type="url"
              pattern="https://.*"
              placeholder="https://"
              {...register("facebookURL")}
            />
          </Field>
          <Field
            label="Instagram"
            htmlFor="instagramURL"
            hint="Ex : https://www.instagram.com/exemple"
            error={errors.instagramURL?.message}
          >
            <CFormInput
              id="instagramURL"
              type="url"
              pattern="https://.*"
              placeholder="https://"
              {...register("instagramURL")}
            />
          </Field>
          <Field
            label="TikTok"
            htmlFor="tiktokURL"
            hint="Ex : https://www.tiktok.com/exemple"
            error={errors.tiktokURL?.message}
          >
            <CFormInput
              id="tiktokURL"
              type="url"
              pattern="https://.*"
              placeholder="https://"
              {...register("tiktokURL")}
            />
          </Field>
        </FormSection>

        {/* Description */}
        <FormSection title="Description">
          <div className="col-12">
            <RichTextEditor
              onChange={setDescription}
              name="description"
              defaultValue={description}
            />
          </div>
        </FormSection>

        {/* Taxi */}
        <FormSection title="Configuration taxi">
          <Field
            label="Taxi actif"
            htmlFor="taxiActive"
            required
            error={errors.taxiActive?.message}
          >
            <CFormSelect id="taxiActive" {...register("taxiActive")}>
              <option value="false">Non</option>
              <option value="true">Oui</option>
            </CFormSelect>
          </Field>
          <Field
            label="Adresse taxi"
            htmlFor="addressName"
            required={taxiOn}
            error={errors.addressName?.message}
          >
            <input
              id="addressName"
              className="form-control"
              placeholder="Adresse"
              {...register("addressName")}
            />
          </Field>
          <Field
            label="Latitude"
            htmlFor="latitude"
            required={taxiOn}
            error={errors.latitude?.message}
          >
            <input
              id="latitude"
              type="number"
              className="form-control"
              step="0.0000000001"
              placeholder="Latitude"
              {...register("latitude")}
            />
          </Field>
          <Field
            label="Longitude"
            htmlFor="longitude"
            required={taxiOn}
            error={errors.longitude?.message}
          >
            <input
              id="longitude"
              type="number"
              className="form-control"
              step="0.0000000001"
              placeholder="Longitude"
              {...register("longitude")}
            />
          </Field>
        </FormSection>

        {/* Events (admin) */}
        {isAdmin && (
          <FormSection title="Accessibilité">
            <Field label="Activer les événements" col="col-12">
              <Controller
                name="isEventsEnabled"
                control={formControl}
                render={({ field }) => (
                  <div className="d-flex align-items-center gap-3">
                    <Switch
                      checked={!!field.value}
                      onChange={(e) => field.onChange(e.currentTarget.checked)}
                      color="orange"
                      size="md"
                    />
                    <span className="fw-medium">
                      {field.value ? "Activé" : "Désactivé"}
                    </span>
                  </div>
                )}
              />
            </Field>
          </FormSection>
        )}

        {/* Configuration (admin) */}
        {isAdmin && (
          <FormSection title="Configuration">
            <Field
              col="col-md-6 col-lg-4"
              label="Sélection de la table"
              htmlFor="supportTableSelection"
              required
              error={errors.supportTableSelection?.message}
            >
              <YesNo
                id="supportTableSelection"
                reg={register("supportTableSelection")}
              />
            </Field>
            <Field
              col="col-md-6 col-lg-4"
              label="Autoriser la réservation"
              htmlFor="supportReservations"
              required
              error={errors.supportReservations?.message}
            >
              <YesNo
                id="supportReservations"
                reg={register("supportReservations")}
              />
            </Field>
            <Field
              col="col-md-6 col-lg-4"
              label="Activer la TVA"
              htmlFor="activateTVA"
              required
              error={errors.activateTVA?.message}
            >
              <YesNo id="activateTVA" reg={register("activateTVA")} />
            </Field>
            <Field
              col="col-md-6 col-lg-4"
              label="Pourcentage Venez"
              htmlFor="venezPercentage"
              required
              error={errors.venezPercentage?.message}
            >
              <CFormInput
                id="venezPercentage"
                type="number"
                placeholder="%"
                {...register("venezPercentage")}
              />
            </Field>
            <Field
              col="col-md-6 col-lg-4"
              label="Confirmer automatiquement les réservations"
              htmlFor="authConfirmBookings"
              required
              error={errors.authConfirmBookings?.message}
            >
              <YesNo
                id="authConfirmBookings"
                reg={register("authConfirmBookings")}
              />
            </Field>
            <Field
              col="col-md-6 col-lg-4"
              label="Visible"
              htmlFor="isVisible"
              required
              hint="Contrôle la visibilité dans l'application et le site web"
              error={errors.isVisible?.message}
            >
              <YesNo id="isVisible" reg={register("isVisible")} />
            </Field>
            <Field
              col="col-md-6 col-lg-4"
              label="Étape entre les heures"
              htmlFor="hoursStep"
              required
              hint="Intervalle en minutes entre les heures de réservation (ex : 30)"
              error={errors.hoursStep?.message}
            >
              <input
                id="hoursStep"
                type="number"
                className="form-control"
                {...register("hoursStep")}
              />
            </Field>
            <Field
              col="col-md-6 col-lg-8"
              label="Méthodes de paiement"
              required
            >
              <div className="d-flex flex-wrap gap-4 pt-1">
                <CFormCheck
                  id="paymentMethodsCreditCard"
                  label="Carte bancaire"
                  {...register("paymentMethodsCreditCard")}
                />
                <CFormCheck
                  id="paymentMethodsWafacash"
                  label="Wafacash"
                  {...register("paymentMethodsWafacash")}
                />
                <CFormCheck
                  id="paymentMethodsInPlace"
                  label="Sur place"
                  {...register("paymentMethodsInPlace")}
                />
                <CFormCheck
                  id="paymentMethodsStripe"
                  label="Stripe"
                  {...register("paymentMethodsStripe")}
                />
                <CFormCheck
                  id="paymentMethodsBalance"
                  label="Solde utilisateur"
                  {...register("paymentMethodsBalance")}
                />
              </div>
            </Field>
          </FormSection>
        )}

        {/* Company */}
        <FormSection title="Informations de la société">
          <Field
            col="col-md-6 col-lg-4"
            label="Nom de la société"
            htmlFor="companyName"
            error={errors.companyName?.message}
          >
            <CFormInput id="companyName" {...register("companyName")} />
          </Field>
          <Field
            col="col-md-6 col-lg-4"
            label="Adresse de la société"
            htmlFor="companyAddress"
            error={errors.companyAddress?.message}
          >
            <CFormInput id="companyAddress" {...register("companyAddress")} />
          </Field>
          <Field
            col="col-md-6 col-lg-4"
            label="IF"
            htmlFor="IF"
            error={errors.IF?.message}
          >
            <CFormInput id="IF" {...register("IF")} />
          </Field>
          <Field
            col="col-md-6 col-lg-4"
            label="IC"
            htmlFor="IC"
            error={errors.IC?.message}
          >
            <CFormInput id="IC" {...register("IC")} />
          </Field>
          <Field
            col="col-md-6 col-lg-4"
            label="RIB"
            htmlFor="rib"
            error={errors.rib?.message}
          >
            <CFormInput id="rib" {...register("rib")} />
          </Field>
        </FormSection>

        {/* Place admin + managers (admin) */}
        {isAdmin && (
          <FormSection title="Administrateur de l'établissement">
            <Field
              label="Nom et prénom"
              htmlFor="adminFullName"
              error={errors.adminFullName?.message}
            >
              <CFormInput
                id="adminFullName"
                placeholder="Nom et prénom"
                {...register("adminFullName")}
              />
            </Field>
            <Field
              label="Email"
              htmlFor="adminEmail"
              error={errors.adminEmail?.message}
            >
              <CFormInput
                id="adminEmail"
                type="email"
                autoComplete="new-admin-email"
                {...register("adminEmail")}
              />
            </Field>
            <Field
              label="Téléphone"
              htmlFor="adminPhone"
              error={errors.adminPhone?.message}
            >
              <CFormInput
                id="adminPhone"
                placeholder="Téléphone"
                {...register("adminPhone")}
              />
            </Field>
            {isCreate && (
              <div className="col-md-6">
                <PasswordInput
                  isRequired
                  className="custom-input"
                  placeholder="Mot de passe"
                  id="adminPassword"
                  name="adminPassword"
                  autoComplete="new-password"
                  onChange={(val) =>
                    setFormValue("adminPassword", val?.target?.value)
                  }
                  labelText="Mot de passe"
                />
                {errors.adminPassword?.message && (
                  <div style={{ color: "#dc3545", fontSize: 12 }}>
                    {errors.adminPassword.message}
                  </div>
                )}
              </div>
            )}

            <div className="col-12">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <span className="fw-semibold" style={{ fontSize: 13 }}>
                  Managers {managers.length > 0 && `(${managers.length})`}
                </span>
                <button
                  type="button"
                  onClick={() => setShowUser(!showUser)}
                  className="btn btn-sm btn-outline-primary rounded-pill px-3"
                >
                  {showUser ? "Fermer la sélection" : "+ Ajouter un manager"}
                </button>
              </div>

              {showUser && (
                <div className="mb-3">
                  <InfiniteScrollSelect
                    name="managerIds"
                    isClearable={false}
                    getOptionLabel={(o) => `${o.fullName} (${o.email})`}
                    getOptionValue={(o) => o.id}
                    onChange={(selected) => addManager(selected)}
                    placeholder="Choisissez un utilisateur"
                    url={{ path: "users/place-admin" }}
                  />
                </div>
              )}

              <div className="d-flex flex-column gap-2">
                {managers.length === 0 && (
                  <div
                    className="text-center text-muted py-3"
                    style={{
                      border: "1px dashed #ddd",
                      borderRadius: 12,
                      fontSize: 13,
                    }}
                  >
                    Aucun manager assigné
                  </div>
                )}
                {managers.map((manager) => (
                  <div
                    key={manager.id}
                    className="d-flex justify-content-between align-items-center px-3 py-2"
                    style={{
                      border: "1px solid #eee",
                      borderRadius: 12,
                      backgroundColor: "#fcfcfc",
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="d-inline-flex align-items-center justify-content-center rounded-circle fw-bold flex-shrink-0"
                        style={{
                          width: 34,
                          height: 34,
                          color: ACCENT,
                          backgroundColor: "rgba(240,129,63,0.14)",
                        }}
                      >
                        {(manager.fullName?.[0] ?? "?").toUpperCase()}
                      </span>
                      <div>
                        <div className="fw-semibold" style={{ fontSize: 14 }}>
                          {manager.fullName}
                        </div>
                        <div className="text-muted" style={{ fontSize: 12 }}>
                          {manager.email}
                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger rounded-pill px-3"
                      onClick={() => removeManager(manager.id)}
                    >
                      Retirer
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </FormSection>
        )}

        {/* Sticky actions */}
        <div
          className="d-flex justify-content-end gap-2 py-3 px-3 mt-3"
          style={{
            position: "sticky",
            bottom: 0,
            zIndex: 5,
            backgroundColor: "#fff",
            borderRadius: 16,
            boxShadow: "0 -4px 16px rgba(0,0,0,0.06)",
          }}
        >
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="btn btn-outline-secondary rounded-pill px-4"
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={formLoading}
            className="btn btn-success text-white rounded-pill px-4"
          >
            {formLoading ? <CSpinner size="sm" /> : "Enregistrer"}
          </button>
        </div>
      </form>
    </div>
  );
}
